const normalizeTeamLookupValue = (value) =>
  String(value ?? '')
    .trim()
    .replace(/\s+/g, ' ')
    .toLocaleLowerCase('uk-UA');

export const FC_KHARKIV = Object.freeze({
  id: 'fc-kharkiv',
  name: 'ФК Харків',
  slug: 'fc-kharkiv',
  route: '/football-ukraine/fc-kharkiv',
  aliases: Object.freeze(['Металіст 1925', 'metalist1925']),
  sectionAliases: Object.freeze(['Металіст 1925']),
  legacyRoutes: Object.freeze(['/football-ukraine/metalist1925']),
});

export const canonicalTeams = Object.freeze([FC_KHARKIV]);

const teamByName = new Map();
const teamByRoute = new Map();

canonicalTeams.forEach((team) => {
  [team.id, team.name, team.slug, ...team.aliases].forEach((value) => {
    teamByName.set(normalizeTeamLookupValue(value), team);
  });
  [team.route, ...team.legacyRoutes].forEach((route) => {
    teamByRoute.set(route, team);
  });
});

export const resolveCanonicalTeam = (value) =>
  teamByName.get(normalizeTeamLookupValue(value)) || null;

export const getCanonicalTeamName = (value) =>
  resolveCanonicalTeam(value)?.name || String(value ?? '').trim();

export const getCanonicalTeamRoute = (value) =>
  resolveCanonicalTeam(value)?.route || null;

export const getTeamSectionQueryValues = (value) => {
  const team = resolveCanonicalTeam(value);
  if (!team) {
    const cleanValue = String(value ?? '').trim();
    return cleanValue ? [cleanValue] : [];
  }

  return [...new Set([team.name, ...team.sectionAliases])];
};

export const normalizeTeamSections = (sections) => {
  if (!Array.isArray(sections)) return [];

  return [...new Set(
    sections
      .map(getCanonicalTeamName)
      .filter(Boolean)
  )];
};

export const resolveTeamByRoute = (route) => teamByRoute.get(route) || null;
